import styled from 'styled-components';

export const MessageContainer = styled.div`
  text-align: center;
  padding: 56px 24px;
  color: #999;
  font-size: 13px;
`;

export const ErrorMessage = styled(MessageContainer)`
  color: #f87171;
`;

export const StatusBadgeWrapper = styled.span<{ $bg: string; $color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 32px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  white-space: nowrap;
`;

export const DateInput = styled.input`
  height: 2rem;
  width: 8.5rem;
  padding: 0 0.5rem 0 0.8rem;
  border: none;
  border-radius: 32px;
  font-size: 0.8rem;
  color: #303030;
  background: #ebebeb;
  font-family: 'Inter', sans-serif;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 1.5px #0090d3;
  }
`;

export const SelectButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border: none;
  border-radius: 32px;
  background: #ebebeb;
  font-size: 13px;
  color: #303030;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
`;

export const DropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 100;
  min-width: 200px;
  background: #fff;
  border: 1.5px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.14);
  padding: 6px 0;
`;

export const DropdownOption = styled.button<{ $active?: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 14px;
  border: none;
  background: ${({ $active }) => ($active ? '#e6f4fb' : 'transparent')};
  color: ${({ $active }) => ($active ? '#0090d3' : '#303030')};
  font-size: 13px;
  cursor: pointer;
`;

export const RelativeWrap = styled.div`
  position: relative;
`;
